import React from 'react';
import { Container } from 'react-bootstrap';
import PageHeading from './PageHeading';

function PrivacyPolicyPage() {
  return (
    <Container className="Center-column legal-page">
      <div className="pg-break"> </div>
      <PageHeading icon="shield">Privacy Policy</PageHeading>
      <div className="legal-content">
        <p className="legal-updated">Last updated: September 19, 2026</p>

        <h2>Introduction</h2>
        <p>
          Nature&apos;s Nefer (&quot;we,&quot; &quot;us,&quot; or
          &quot;our&quot;) respects your privacy. This policy explains what
          information we collect, how we use it, and the choices you have when
          you visit our website or place an order.
        </p>

        <h2>Information We Collect</h2>
        <p>We may collect:</p>
        <ul>
          <li>
            Account details such as name, email address, and password when you
            create an account
          </li>
          <li>
            Order and shipping information needed to fulfill your purchase
          </li>
          <li>
            Payment information processed securely by our payment provider
            (we do not store full card numbers on our servers)
          </li>
          <li>
            Basic usage data such as pages visited and device or browser type
          </li>
        </ul>

        <h2>How We Use Your Information</h2>
        <p>We use your information to:</p>
        <ul>
          <li>Process and deliver orders</li>
          <li>Create and manage your account</li>
          <li>Send order confirmations and account-related messages</li>
          <li>Improve our website and customer experience</li>
          <li>Respond to questions and support requests</li>
        </ul>

        <h2>Sharing of Information</h2>
        <p>
          We do not sell your personal information. We may share data with
          trusted service providers who help us operate the site, process
          payments, or ship orders—only as needed to provide those services.
          We may also disclose information when required by law.
        </p>

        <h2>Cookies</h2>
        <p>
          Our site may use cookies or similar technologies to keep you signed
          in, remember bag contents, and understand how the site is used. You
          can control cookies through your browser settings.
        </p>

        <h2>Data Security</h2>
        <p>
          We take reasonable steps to protect your information. No method of
          transmission over the internet is completely secure, so we cannot
          guarantee absolute security.
        </p>

        <h2>Your Choices</h2>
        <p>
          You may update your account information while signed in, or contact
          us to request access, correction, or deletion of personal data we
          hold about you, subject to legal and operational requirements.
        </p>

        <h2>Changes</h2>
        <p>
          We may update this policy from time to time. The &quot;Last
          updated&quot; date at the top will reflect the latest revision.
        </p>

        <h2>Contact</h2>
        <p>
          For privacy-related questions, please contact Nature&apos;s Nefer
          through the support options available on our website.
        </p>
      </div>
    </Container>
  );
}

export default PrivacyPolicyPage;
